import Vue from "vue"
import Vuex from "vuex"


Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        screenWidth: 0,
        lang: 'cn',
        count: 0, 
        openSkeleton: false,
        bannerData: {
            aboutus: {
                content: null,
                mobile_pic_url: null,
                pic: null,
                pic_url: null,
                title: '关于慢吉'
            }
        },
        trialData: '',
        updateLoading: false,
        storeCommon: '',
        aboutData: ''
    },
    getters: {
        // 参数列表state指的是state数据
        getClientWidth(state) {
            return state.screenWidth;
        },
    },
    // 3. actions
    // 通常跟api接口打交道
    actions: {

    },
    mutations: {
        // 保存当前屏幕宽度
        setClientWidth(state, screenWidth) {
            state.screenWidth = screenWidth;
        },
        setLang(state, data) {
            state.lang = data;
        },
        updateCount(state, num) {
            state.count++
        },
        setSkeleton(state, value) {
            state.openSkeleton = value
        },
        setBanner(state, value) {
            state.bannerData = value
        },
        setTrial(state, value) {
            state.trialData = value
        },
        setLoading(state, value) {
            state.updateLoading = value
        },
        setCommon(state, value) {
            state.storeCommon = value
        },
        setAboutData(state, value) {
            state.aboutData = value
        },
    }

})


// WEBPACK FOOTER //
// ./src/store/index.js